export const Image = {
    order : require('./Images/order.png')
}